import React from 'react'


const Banner = () => {
  // const bannerStyle={
  //   backgroundImage: `url(${BannerImg})`,
  //   minHeight: '25vh',
  //   backgroundPosition: '0 -150px'
  // }
  return ( 
    <>
      <section className="section-banner__pages" >
        
      </section>
    </>
   );
}
 
export default Banner;